/**
 * Created by xuyq on 2021/1/8.
 */
import index from './view/index'

export default () => {
  let menu =
    {
      path: '/',
      name: 'anonymous',
      title: '匿名访问',
      hidden: true,
      component: index,
      meta: {
        layout: 'content',
        anonymous:true
      },
    }
  return {
    menu,
    // store
  }
}
